import React, { useContext } from 'react';
import Toggle from './Toggle';
import { store } from '../Context/Store';
// import styled from 'styled-components';
import SettingsBox from './SettingsBox';

export default function VisualImpairment() {
  const { globalState, dispatch } = useContext(store);

  return (
    <SettingsBox title={'Visual Impairment'}>
      <Toggle
        onChange={() =>
          dispatch({
            type: globalState.visualImpairment
              ? 'UNSET_VISUAL_IMPAIRMENT'
              : 'SET_VISUAL_IMPAIRMENT',
          })
        }
        checked={globalState.visualImpairment}
      />
    </SettingsBox>
  );
}

// const Container = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   padding: 0.5rem 1rem;
//   h5 {
//     margin-right: 0.5rem;
//     color: lightgrey;
//     font-size: 0.7rem;
//   }
// `;
